const mLogOut = {
  mLogOut: {
    message: 'Saliendo de Vidroop'
  }
}

export default mLogOut
